export enum AlertNotificationMethod {
  Email = 'Email',
  SMS = 'SMS',
}
